import { type FC } from "react"
import { useForm } from "react-hook-form"

import { CostBreakdownCompletedFilter } from "./CostBreakdownCompletedFilter"
import { CostBreakdownManagedInAs400Filter } from "./CostBreakdownManagedInAs400Filter"

import { SearchFilterDrawer } from "@/components/common/SearchFilterDrawer/SearchFilterDrawer"
import { GoodsReceiptWarehouseFilter } from "@/screens/WarehouseReceiving/components/GoodsReceiptsTable/GoodsReceiptWarehouseFilter"
import type { GoodsReceiptFilterFormValues } from "@/screens/WarehouseReceiving/types"
import type { Option } from "@/types/form-fields"

interface CostBreakdownFilterFormValues extends GoodsReceiptFilterFormValues {
  isProductCostCompleted?: boolean[]
  isManagedInAs400?: boolean[]
}

interface CostBreakdownFilterDrawerProps {
  isOpen: boolean
  warehouseAreaIds: string[]
  warehouseOptions: Option<string>[]
  isWarehousesFetching: boolean
  isProductCostCompleted?: boolean[]
  isManagedInAs400?: boolean[]
  onToggle: () => void
  onChange: (warehouseIds: string[]) => void
  onCompletedChange: (isProductCostCompleted?: boolean[]) => void
  onManagedInAs400Change: (isManagedInAs400?: boolean[]) => void
  onClear: () => void
}

export const CostBreakdownFilterDrawer: FC<CostBreakdownFilterDrawerProps> = ({
  isOpen,
  warehouseAreaIds,
  warehouseOptions,
  isWarehousesFetching,
  isProductCostCompleted,
  isManagedInAs400,
  onToggle,
  onChange,
  onCompletedChange,
  onManagedInAs400Change,
  onClear,
}) => {
  const { control } = useForm<CostBreakdownFilterFormValues>({
    defaultValues: {
      warehouseAreaIds,
      isProductCostCompleted,
      isManagedInAs400,
    },
  })

  return (
    <SearchFilterDrawer open={isOpen} toggleDrawer={onToggle} clear={onClear} testId='cost-breakdown-filter-drawer'>
      <CostBreakdownCompletedFilter
        control={control}
        selectedValues={isProductCostCompleted}
        onChange={onCompletedChange}
      />
      <CostBreakdownManagedInAs400Filter
        control={control}
        selectedValues={isManagedInAs400}
        onChange={onManagedInAs400Change}
      />
      <GoodsReceiptWarehouseFilter
        control={control}
        isFetching={isWarehousesFetching}
        options={warehouseOptions}
        selectedValues={warehouseAreaIds}
        onChange={onChange}
      />
    </SearchFilterDrawer>
  )
}
